// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_dt-a";
export var fulfillmentFormRail = "_dt-9";
export var headerTitleRow = "_dt-c";
export var orderDetailsWrapper = "_dt-7";
export var orderLinkTrigger = "_dt-2";
export var paymentInformationGrid = "_dt-h";
export var paymentSummaryColumn = "_dt-i";
export var shipmentContainer = "_dt-b";
export var shipmentDetailsMainPane = "_dt-8";
export var shipmentNavigationCard = "_dt-5";
export var shipmentNavigationRail = "_dt-3";
export var shipmentNavigationRailHeader = "_dt-4";
export var shipmentSummaryFact = "_dt-e";
export var shipmentSummaryGrid = "_dt-d";
export var shipmentSummaryMetadataRow = "_dt-f";
export var shipmentSummaryTags = "_dt-g";
export var shipmentWorkspace = "_dt-0";
export var shipmentWorkspaceContent = "_dt-6";
export var shipmentWorkspaceHeader = "_dt-1";